
module.exports = {
	REQUEST_TOTAL_SCORES: "REQUEST_TOTAL_SCORES",
	RECEIVE_TOTAL_SCORES: "RECEIVE_TOTAL_SCORES",
	REQUEST_TOTAL_SCORES_ERROR: "REQUEST_TOTAL_SCORES_ERROR",
    REQUEST_MYQOL_SCORES: "REQUEST_MYQOL_SCORES",
	RECEIVE_MYQOL_SCORES: "RECEIVE_MYQOL_SCORES",
	REQUEST_MYQOL_SCORES_ERROR: "REQUEST_MYQOL_SCORES_ERROR",
    REQUEST_LATEST_HPI: "REQUEST_LATEST_HPI",
	RECEIVE_LATEST_HPI: "RECEIVE_LATEST_HPI",
	REQUEST_LATEST_HPI_ERROR: "REQUEST_LATEST_HPI_ERROR",
    DASHBOARD_SET_ACTIVE_ITEMS: "DASHBOARD_SET_ACTIVE_ITEMS",
    DASHBOARD_CLEAR_ACTIVE_ITEMS: "DASHBOARD_CLEAR_ACTIVE_ITEMS",
    SET_ALARM_SYMPTOM_RESPONSES: "SET_ALARM_SYMPTOM_RESPONSES",
    DASHBOARD_CLEAR: "DASHBOARD_CLEAR",
	SEND_HPI_BEGIN: "SEND_HPI_BEGIN",
	SEND_HPI_SUCCESS: "SEND_HPI_SUCCESS",
	SEND_HPI_FAILURE: "SEND_HPI_FAILURE",
	CLEAR_SEND_HPI_STATUS: "CLEAR_SEND_HPI_STATUS"
};



// WEBPACK FOOTER //
// ./src/common/modules/dashboard/constants.js